import { useGetFaireAcademyPageState } from "@faire/deprecated-retailer-visitor-shared/hooks/openWithFaire/useGetFaireAcademyPageState";
import { ShareOffer } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/FooterCard/ShareOffer";
import { getOpenWithFaireFooterCardTitleText } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/FooterCard/utils";
import { SignUpButton } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/SignUpButton";
import {
  FAInnerWrapperColumn,
  FAOuterWrapper,
} from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/styles";
import { OWF_BACKGROUND } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/imagesData";
import { OWF_SECTION_NAME } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/types";
import { Core } from "@faire/design-tokens";
import { trackOpenWithFaireOwfApplicationCtaClick } from "@faire/web-api--source/events/openWithFaire/click/owfApplicationCta";
import { trackOpenWithFaireFaireAcademySectionView } from "@faire/web-api--source/events/openWithFaire/view/faireAcademySection";
import owfApplication from "@faire/web-api--source/routes/www/net-terms/owf-application";
import { Button } from "@faire/web/slate/Button";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { SlideIn } from "@faire/web/ui/SlideIn/SlideIn";
import React from "react";
import styled from "styled-components";

export const FooterCard: React.FC = () => {
  const { pageState, isLoggedInNewApplied } = useGetFaireAcademyPageState();
  const ref = useDoActionWhenVisible(() =>
    trackOpenWithFaireFaireAcademySectionView(
      pageState,
      OWF_SECTION_NAME.FOOTER_CARD
    )
  );

  if (isLoggedInNewApplied) {
    return null;
  }

  return (
    <FooterWrapper data-test-id="owf-fa-footer" ref={ref}>
      <SlideIn offset="50px">
        <FooterContent>
          <FooterTitle />
          <FooterBody />
        </FooterContent>
      </SlideIn>
    </FooterWrapper>
  );
};

const FooterTitle: React.FC = () => {
  const { pageState } = useGetFaireAcademyPageState();

  const titleText = getOpenWithFaireFooterCardTitleText(pageState);

  return (
    <WhiteTypography
      align="center"
      variant={{
        mobileAndAbove: "displayMSerifRegular",
        desktopAndAbove: "displayLSerifRegular",
      }}
    >
      {titleText}
    </WhiteTypography>
  );
};

const FooterBody: React.FC = () => {
  const { pageState, isLoggedInNewNotApplied, isLoggedInEstablished } =
    useGetFaireAcademyPageState();

  if (isLoggedInNewNotApplied) {
    return (
      <>
        <Spacer
          height={{
            mobileAndAbove: "4x",
            desktopAndAbove: "5x",
          }}
        />
        <FitContentButton
          variant="secondary"
          linkTo={owfApplication()}
          onClick={() =>
            trackOpenWithFaireOwfApplicationCtaClick(
              pageState,
              OWF_SECTION_NAME.FOOTER_CARD
            )
          }
        >
          <StrictLocalMsg
            id="5HBZBM"
            defaultMessage="Apply in minutes"
            description={{
              text: "CTA text to the application form from the Open with Faire landing page, for logged in & new customers",
              img: "https://cdn.faire.com/fastly/dbaa8da25fff5050bf679e93e754f10c481a41c4c97e3d13bd9a4b8a3cfe4b10.png",
            }}
          />
        </FitContentButton>
      </>
    );
  }

  if (isLoggedInEstablished) {
    return (
      <>
        <Spacer
          height={{
            mobileAndAbove: "4x",
            desktopAndAbove: "5x",
          }}
        />
        <ShareOffer />
      </>
    );
  }

  return (
    <>
      <Spacer
        height={{
          mobileAndAbove: "4x",
          desktopAndAbove: "5x",
        }}
      />
      <SignUpButton source={OWF_SECTION_NAME.FOOTER_CARD} />
    </>
  );
};

const FooterWrapper = styled(FAOuterWrapper)`
  height: 438px;
  background-image: url(${OWF_BACKGROUND});

  ${responsiveMediaQueries.tabletAndBelow} {
    height: fit-content;
  }
`;

const FooterContent = styled(FAInnerWrapperColumn).attrs({
  justify: "space-between",
})`
  ${responsiveMediaQueries.tablet} {
    padding: ${getSpacing("9x", 100)};
  }
  ${responsiveMediaQueries.mobile} {
    padding: ${getSpacing("4x", "8x", "8x", "8x")};
  }
`;

const WhiteTypography = styled(Typography).attrs({
  color: Core.text.inverse,
})``;

const FitContentButton = styled(Button)`
  width: fit-content;
  align-self: center;

  ${responsiveMediaQueries.mobile} {
    width: 100%;
  }
`;
